var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "shipping-page" } },
    [
      _c("loading-overlay", {
        attrs: {
          active: _vm.displayLoader,
          loader: "dots",
          color: "#1A74DB",
          height: "30",
          width: "100%",
          opacity: "0.85",
        },
        on: {
          "update:active": function ($event) {
            _vm.displayLoader = $event
          },
        },
      }),
      _vm._v(" "),
      _vm.pageDataFetched
        ? _c(
            "div",
            [
              _c("checkout-header", {
                attrs: {
                  categoryFilter: { display: false },
                  shoppingBag: { display: false },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "body" } },
                [
                  _vm.displayDiscountExpiredNotice
                    ? _c("notice", {
                        attrs: { noticeType: "notice" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.discountExpiredNotice) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1336327497
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasMultilineShipping
                    ? _c("notice", {
                        attrs: { noticeType: "notice" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.checkoutSharedContent
                                          .multilineShippingReadOnlyNotice
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1582338102
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.contract.isContractOnFile &&
                  _vm.checkoutType === "ExpressCheckout"
                    ? _c("notice", {
                        attrs: { noticeType: "notice" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "content",
                              fn: function () {
                                return [
                                  _c("div", [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.checkoutContent.clientMessages
                                            .express_checkout_co_term.text
                                        ) +
                                        " \n                        "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        staticStyle: {
                                          color: "#2a6496",
                                          "text-decoration": "underline",
                                        },
                                        attrs: {
                                          href: _vm.checkoutContent
                                            .clientMessages
                                            .express_checkout_co_term.url,
                                          target: "”_blank”",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.checkoutContent.clientMessages
                                              .express_checkout_co_term.url_text
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          3731473716
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.accountCreationNeeded
                    ? _c(
                        "div",
                        [
                          _vm._m(0),
                          _vm._v(" "),
                          _c("user-form", {
                            ref: "account",
                            attrs: {
                              formModule: "account",
                              formModel: { ..._vm.account },
                              formSchema: _vm.accountFormSchema,
                              formPlaceholders:
                                _vm.checkoutContent.formPlaceholders,
                              formHints: _vm.checkoutContent.formHints,
                              formValidationErrorMessages:
                                _vm.checkoutContent.validationErrorMessages,
                              formSelectFieldOptions: {},
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col xs-12" }, [
                      _c("h3", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(_vm.checkoutContent.shippingDetails)),
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mt-0 mb-1" }, [
                        _c("span", { staticClass: "icon small inline truck" }),
                        _vm._v(
                          "   " + _vm._s(_vm.checkoutContent.enterShippingInfo)
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("user-form", {
                    ref: "shipping",
                    attrs: {
                      formModule: "shipping",
                      formModel: { ..._vm.shipping },
                      formSchema: _vm.shippingFormSchema,
                      formPlaceholders: _vm.checkoutContent.formPlaceholders,
                      formHints: _vm.checkoutContent.formHints,
                      formValidationErrorMessages:
                        _vm.checkoutContent.validationErrorMessages,
                      formSelectFieldOptions: {},
                      formRadiosFieldOptions: _vm.shippingRadiosFieldsToOptions,
                      formOverrides: _vm.shippingFormOverrides,
                    },
                  }),
                  _vm._v(" "),
                  _vm.doAnyProductInCartHaveShippingDelays
                    ? _c("p", { staticClass: "shipping-method-disclaimer" }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.checkoutContent.shippingMethodOptions
                                .shipping_disclaimer
                            ) +
                            "\n            "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isExpressFirstPurchase
                    ? [
                        _c(
                          "div",
                          { staticClass: "row", attrs: { id: "billing-info" } },
                          [
                            _c("h3", { staticClass: "col xs-12" }, [
                              _vm._v(
                                _vm._s(_vm.checkoutContent.billingDetails)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.isBillingDifferentThanShipping,
                                    expression:
                                      "isBillingDifferentThanShipping",
                                  },
                                ],
                                attrs: {
                                  type: "checkbox",
                                  id: "shipping-billing-equal",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.isBillingDifferentThanShipping
                                  )
                                    ? _vm._i(
                                        _vm.isBillingDifferentThanShipping,
                                        null
                                      ) > -1
                                    : _vm.isBillingDifferentThanShipping,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a =
                                        _vm.isBillingDifferentThanShipping,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.isBillingDifferentThanShipping =
                                            $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.isBillingDifferentThanShipping =
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.isBillingDifferentThanShipping = $$c
                                    }
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { attrs: { for: "shipping-billing-equal" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.checkoutContent
                                        .billingAndShippingDifferent
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isBillingDifferentThanShipping
                          ? _c("user-form", {
                              ref: "billing",
                              attrs: {
                                formModule: "billing",
                                formModel: { ..._vm.billing },
                                formSchema: _vm.billingFormSchema,
                                formPlaceholders:
                                  _vm.checkoutContent.formPlaceholders,
                                formHints: {},
                                formValidationErrorMessages:
                                  _vm.checkoutContent.validationErrorMessages,
                                formSelectFieldOptions: {},
                                formRadiosFieldOptions: {},
                                formOverrides: {},
                              },
                            })
                          : _vm._e(),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "row",
                      attrs: { id: "checkout-button-container" },
                    },
                    [
                      _c("div", { staticClass: "col xs-12 flex flex-around" }, [
                        _c(
                          "button",
                          {
                            attrs: { id: "checkout-button" },
                            on: { click: _vm.submitHandler },
                          },
                          [_vm._v(_vm._s(_vm.checkoutContent.continueToReview))]
                        ),
                      ]),
                    ]
                  ),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col xs-12" }, [
        _c("h3", { staticClass: "mb-0" }, [_vm._v("Account details")]),
        _vm._v(" "),
        _c("p", { staticClass: "mt-0 mb-1" }, [
          _vm._v("An account is required to place your order."),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }